<div class="account-pages">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">

          <div class="bg-primary-subtle text-center py-4">
            <img src="assets/images/echo-login.png" alt="Echo" class="img-fluid" style="max-height: 72px;">
          </div>

          <div class="card-body p-4 text-center">

            <!-- Held briefly on a phone: the OS may still be handing this to
                 the app, and flashing the fallback first would be wrong. -->
            <ng-container *ngIf="isWaiting">
              <div class="spinner-border text-primary my-4" role="status">
                <span class="visually-hidden">Opening…</span>
              </div>
              <h5 class="mb-1">Opening Echo…</h5>
              <p class="text-muted mb-0">Just a moment.</p>
            </ng-container>

            <ng-container *ngIf="!isWaiting">
              <div class="avatar-md mx-auto mb-4">
                <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                  <i class="bx bx-mobile-alt" style="font-size: 28px;"></i>
                </span>
              </div>

              <h5 class="mb-2">
                {{ isSignInLink ? 'Finish signing in on your phone' : 'Open this in the Echo app' }}
              </h5>

              <!-- The instruction differs by platform because the recovery
                   action does. -->
              <p class="text-muted mb-4" *ngIf="isMobile">
                <ng-container *ngIf="isIos">
                  Tap <strong>Open</strong> in the banner at the top of this page.
                  If you don't see it, install Echo Conversations and open the
                  link again from your email.
                </ng-container>
                <ng-container *ngIf="!isIos">
                  Open the link again from your email and choose
                  <strong>Echo Conversations</strong>. If you don't have the app
                  yet, install it first.
                </ng-container>
              </p>

              <p class="text-muted mb-4" *ngIf="!isMobile">
                {{ isSignInLink
                    ? 'This sign-in link is for the Echo Conversations mobile app. Open this email on your phone to finish signing in.'
                    : 'This link is for the Echo Conversations mobile app. Open it on your phone.' }}
              </p>

              <div class="d-grid gap-2">
                <button type="button" class="btn btn-primary" *ngIf="isMobile" (click)="retryOpenApp()">
                  Try opening the app again
                </button>
                <button type="button" class="btn btn-outline-secondary" (click)="goToPortal()">
                  {{ isSignInLink ? 'Sign in on the web instead' : 'Go to the Echo portal' }}
                </button>
              </div>

              <p class="text-muted mt-4 mb-0" *ngIf="isSignInLink" style="font-size: 12px;">
                Sign-in links can only be used once. If this one has expired,
                request a new one from the app.
              </p>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
